module.exports = "import React from 'react';\n\nclass ComponentName extends React.Component {\n  render() {\n    // Return HTML\n  }\n}\n"